
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Usuarios from "../pages/usuarios/page";
import Horarios from "../pages/horarios/page";
import Reservas from "../pages/reservas/page";
import Pagos from "../pages/pagos/page";
import Ventas from "../pages/ventas/page";
import Rutinas from "../pages/rutinas/page";
import Reportes from "../pages/reportes/page";
import Progreso from "../pages/progreso/page";
import Tutoriales from "../pages/tutoriales/page";
import Notificaciones from "../pages/notificaciones/page";
import BandejaNotificaciones from "../pages/bandeja-notificaciones/page";
import Login from "../pages/login/page";
import Planes from "../pages/planes/page";
import ActivarCuenta from "../pages/activar-cuenta/page";
import Gimnasios from "../pages/gimnasios/page";
import SaasPlanes from "../pages/saas-planes/page";
import PagarServicio from "../pages/pagar-servicio/page";
import PagarServicioReturn from "../pages/pagar-servicio/return";
import ResetPassword from "../pages/reset-password/page";
import PoliticaPrivacidadPage from "../pages/politica-privacidad/page";
import ChatPage from "../pages/chat/page";
import CorreoConfirmadoPage from "../pages/correo-confirmado/page";
import GuestsPage from "../pages/invitados/page";
import CertificacionTransbankPage from "../pages/certificacion-transbank/page";
import ActividadesCoachesPage from "../pages/actividades-coaches/page";
import PresenciaPersonalPage from "../pages/presencia-personal/page";
import InscripcionKioscoPage from "../pages/inscripcion/page";
import InscripcionQrPage from "../pages/inscripcion/qr";
import InscripcionPagoPage from "../pages/inscripcion/pago";
import InscripcionAsistenciaPage from "../pages/inscripcion/asistencia";
import InscripcionAsistenciaPublicaPage from "../pages/inscripcion/asistencia-publica";
import InscripcionesPendientesPage from "../pages/inscripciones-pendientes/page";
import RenovacionPage from "../pages/renovacion/page";
import CoachClientInvitationPage from "../pages/coach-client-invitation/page";
import PropuestasIAPage from "../pages/propuestas-ia/page";
import ProtectedRoute from "../components/auth/ProtectedRoute";

const routes: RouteObject[] = [
  { path: "/coach/invitacion/:token", element: <CoachClientInvitationPage /> },
  { path: "/inscripcion/qr", element: <InscripcionQrPage /> },
  { path: "/inscripcion/pago", element: <InscripcionPagoPage /> },
  { path: "/inscripcion/asistencia/:gimnasioSlug?", element: <InscripcionAsistenciaPublicaPage /> },
  { path: "/inscripcion/:gimnasioSlug?", element: <InscripcionKioscoPage /> },
  { path: "/renovacion", element: <RenovacionPage /> },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/activar-cuenta",
    element: <ActivarCuenta />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/politica-privacidad",
    element: <PoliticaPrivacidadPage />,
  },
  {
    path: "/correo-confirmado",
    element: <CorreoConfirmadoPage />,
  },
  {
    path: "/",
    element: <ProtectedRoute><Home /></ProtectedRoute>,
  },
  {
    path: "/usuarios",
    element: <ProtectedRoute><Usuarios /></ProtectedRoute>,
  },
  {
    path: "/inscripciones-pendientes",
    element: <ProtectedRoute allowedRoles={['platform_admin','gym_admin','admin']}><InscripcionesPendientesPage /></ProtectedRoute>,
  },
  {
    path: "/inscripcion-asistencia",
    element: <ProtectedRoute allowedRoles={['platform_admin','gym_admin','admin']}><InscripcionAsistenciaPage /></ProtectedRoute>,
  },
  {
    path: "/presencia-personal",
    element: <ProtectedRoute allowedRoles={['platform_admin', 'gym_admin', 'admin', 'staff']}><PresenciaPersonalPage /></ProtectedRoute>,
  },
  {
    path: "/planes",
    element: <ProtectedRoute allowedRoles={['platform_admin', 'gym_admin', 'admin']}><Planes /></ProtectedRoute>,
  },
  {
    path: "/horarios",
    element: <ProtectedRoute><Horarios /></ProtectedRoute>,
  },
  {
    path: "/reservas",
    element: <ProtectedRoute><Reservas /></ProtectedRoute>,
  },
  {
    path: "/pagos",
    element: <ProtectedRoute allowedRoles={['platform_admin', 'gym_admin', 'admin']}><Pagos /></ProtectedRoute>,
  },
  {
    path: "/ventas",
    element: <ProtectedRoute allowedRoles={['platform_admin', 'gym_admin', 'admin', 'staff']}><Ventas /></ProtectedRoute>,
  },
  {
    path: "/certificacion-transbank",
    element: <ProtectedRoute allowedRoles={['platform_admin', 'gym_admin', 'admin']}><CertificacionTransbankPage /></ProtectedRoute>,
  },
  {
    path: "/invitados",
    element: <ProtectedRoute allowedRoles={['platform_admin', 'gym_admin', 'admin']}><GuestsPage /></ProtectedRoute>,
  },
  {
    path: "/rutinas",
    element: <ProtectedRoute><Rutinas /></ProtectedRoute>,
  },
  {
    path: "/actividades-coaches",
    element: <ProtectedRoute allowedRoles={['platform_admin', 'gym_admin', 'admin', 'staff']}><ActividadesCoachesPage /></ProtectedRoute>,
  },
  {
    path: "/reportes",
    element: <ProtectedRoute><Reportes /></ProtectedRoute>,
  },
  {
    path: "/progreso",
    element: <ProtectedRoute><Progreso /></ProtectedRoute>,
  },
  {
    path: "/propuestas-ia",
    element: <ProtectedRoute allowedRoles={['platform_admin', 'gym_admin', 'admin', 'staff']}><PropuestasIAPage /></ProtectedRoute>,
  },
  {
    path: "/chat",
    element: <ProtectedRoute allowedRoles={['staff']}><ChatPage /></ProtectedRoute>,
  },
  {
    path: "/tutoriales",
    element: <ProtectedRoute><Tutoriales /></ProtectedRoute>,
  },
  {
    path: "/notificaciones",
    element: <ProtectedRoute allowedRoles={['platform_admin', 'gym_admin', 'admin']}><Notificaciones /></ProtectedRoute>,
  },
  {
    path: "/bandeja-notificaciones",
    element: <ProtectedRoute><BandejaNotificaciones /></ProtectedRoute>,
  },
  {
    path: "/gimnasios",
    element: <ProtectedRoute allowedRoles={['platform_admin']}><Gimnasios /></ProtectedRoute>,
  },
  {
    path: "/saas-planes",
    element: <ProtectedRoute allowedRoles={['platform_admin']}><SaasPlanes /></ProtectedRoute>,
  },
  {
    path: "/pagar-servicio",
    element: <ProtectedRoute allowedRoles={['platform_admin', 'gym_admin', 'admin']}><PagarServicio /></ProtectedRoute>,
  },
  {
    path: "/pagar-servicio/return",
    element: <ProtectedRoute allowedRoles={['platform_admin', 'gym_admin', 'admin']}><PagarServicioReturn /></ProtectedRoute>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
